import React from 'react'

export default function Artist(props) {
    if (!props.artist) return null;
    const { name, images, genres, followers } = props.artist;
    return (
        <div className="row">
            <div className="col-md-6 col-md-offset-3">
                <div className="panel panel-primary text-center">
                    <div className="panel-heading">
                        <h3 className="panel-title">{name}</h3>
                    </div>
                    <div className="panel-body">
                        <img src={images[1].url} alt={name} className="img-responsive img-circle" />
                        <hr />
                        <p className="text-warning"> {genres.join(",")} </p>
                    </div>
                    <div className="panel-footer">
                        <p className="text-info">Followers: {followers.total}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
